import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [walletsAssigned, setWalletsAssigned] = useState(false);

  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId) {
      setError('Keine Session-ID gefunden');
      setLoading(false);
      return;
    }

    // Payment-Status vom Backend abrufen und Wallets zuordnen
    const checkPaymentStatus = async () => {
      try {
        const response = await fetch(`http://localhost:3001/api/stripe/payment-status/${sessionId}`, {
          credentials: 'include'
        });

        if (response.ok) {
          const data = await response.json();
          setPaymentData(data);
          
          // 🚀 AUTOMATISCH Wallets zuordnen wenn bezahlt!
          if (data.status === 'paid' && !walletsAssigned) {
            await assignWalletsToPurchase(data.year);
          }
        } else {
          setError('Fehler beim Abrufen des Zahlungsstatus');
        }
      } catch (error) {
                setError('Netzwerkfehler');
      } finally {
        setLoading(false);
      }
    };

    checkPaymentStatus();
  }, [sessionId]);

  // Wallets dem Kauf zuordnen
  const assignWalletsToPurchase = async (year) => {
        
    try {
      // Plan aus mehreren Quellen lesen mit Fallbacks
      const planFromQuery = searchParams.get('plan');
      const plan = paymentData?.plan || planFromQuery || localStorage.getItem('selectedPlan');
      
      if (!plan) {
                alert('❌ Fehler: Kein Plan gefunden. Bitte kontaktiere den Support.');
        return;
      }
      
            
      // Hole die aktuell analysierten Wallets aus dem localStorage
      const analyzedWallets = JSON.parse(localStorage.getItem('analyzedWallets') || '[]');
            
      if (analyzedWallets.length > 0) {
        // Sammle alle Wallet-Adressen
        const walletsList = analyzedWallets.map(w => w.wallet).filter(Boolean);
                
                 if (walletsList.length > 0) {
                      
           // 🚀 Sammle ALLE Wallet-Paare (Haupt + VeDelegate) für den Kauf
           const walletPairs = [];
           
           analyzedWallets.forEach(walletEntry => {
             // Wallet-Paar erstellen
             const pair = {
               mainWallet: walletEntry.wallet,
               delegateWallet: walletEntry.delegateWallet || null,
               mainTxCount: walletEntry.mainTxCount || 0,
               delegateTxCount: walletEntry.veDelegateTxCount || 0,
               vet: walletEntry.vet || 0,
               vtho: walletEntry.vtho || 0,
               b3tr: walletEntry.b3tr || 0,
               nft: walletEntry.nft || 0
             };
             
             walletPairs.push(pair);
           });
           
                      
           // 🚀 Verwende den direkten Purchase-API-Endpunkt
           const response = await fetch('http://localhost:3001/api/auth/purchase', {
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
             },
             credentials: 'include',
             body: JSON.stringify({
               walletPairs: walletPairs, // 🚀 WICHTIG: Wallet-Paare statt flache Liste!
               plan: plan,
               year: year
             })
           });

                    
          if (response.ok) {
            const responseData = await response.json();
                        
            // 🚀 Flag setzen, dass Wallets bereits zugeordnet wurden
            setWalletsAssigned(true);
            
            // 🧹 localStorage leeren nach erfolgreichem Kauf
            localStorage.removeItem('analyzedWallets');
             
                          // 🚀 Erfolgs-Flag im localStorage setzen für App.jsx
              const totalWalletCount = walletPairs.length;
              const mainWalletCount = walletPairs.length;
              const delegateWalletCount = walletPairs.filter(p => p.delegateWallet).length;
             
             let message;
             if (language === 'de') {
                            message = `${totalWalletCount} Wallet${totalWalletCount > 1 ? 's' : ''} wurden erfolgreich gekauft! Berechnung kann unter "Meine Wallets" gestartet werden.`;
             } else {
               message = `${totalWalletCount} wallet${totalWalletCount > 1 ? 's' : ''} were successfully purchased! Calculation can be started under "My Wallets".`;
             }
            
            localStorage.setItem('purchaseSuccess', JSON.stringify({
              success: true,
              message: message,
              timestamp: Date.now(),
              year: year || paymentData?.year || null,
              plan: plan || paymentData?.plan || null
            }));
            
            // Kein Toast hier - wird in App.jsx angezeigt
          } else {
            const errorData = await response.json();
                        alert('❌ Fehler beim Speichern der Wallets. Bitte kontaktiere den Support.');
          }
        } else {
                  }
      } else {
              }
    } catch (error) {
          }
  };


  const handleContinue = () => {
    navigate('/'); // Zurück zur Hauptseite
  };

  const t = (key) => {
    const translations = {
      'payment_successful': { 'en': 'Payment Successful!', 'de': 'Zahlung erfolgreich!' },
      'thank_you': { 'en': 'Thank you for your purchase!', 'de': 'Vielen Dank für Ihren Kauf!' },
      'plan_details': { 'en': 'Plan Details', 'de': 'Plan-Details' },
      'plan': { 'en': 'Plan', 'de': 'Plan' },
      'year': { 'en': 'Year', 'de': 'Jahr' },
      'session_id': { 'en': 'Session ID', 'de': 'Session-ID' },
      'continue': { 'en': 'Continue to Analysis', 'de': 'Zur Analyse weiter' },
      'loading': { 'en': 'Verifying payment...', 'de': 'Zahlung wird verifiziert...' },
      'error': { 'en': 'Error', 'de': 'Fehler' }
    };
    return translations[key]?.[language] || key;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">{t('loading')}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <div className="text-red-500 text-6xl mb-4">❌</div>
          <h1 className="text-2xl font-bold text-red-600 mb-4">{t('error')}</h1>
          <p className="text-gray-600 mb-6">{error}</p>
          <button
            onClick={handleContinue}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
          >
            {t('continue')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="text-center">
          <div className="text-green-500 text-6xl mb-4">✅</div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {t('payment_successful')}
          </h1>
          <p className="text-gray-600 mb-8">
            {t('thank_you')}
          </p>
        </div>

        {paymentData && (
          <div className="bg-gray-50 rounded-lg p-6 mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">
              {t('plan_details')}
            </h2>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600">{t('plan')}:</span>
                <span className="font-medium">{paymentData.plan}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">{t('year')}:</span>
                <span className="font-medium">{paymentData.year}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">{t('session_id')}:</span>
                <span className="font-mono text-sm text-gray-500">
                  {sessionId?.slice(0, 8)}...
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="space-y-3">
          <button
            onClick={handleContinue}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-medium transition-colors"
          >
            {t('continue')}
          </button>
          

          

        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
